import React, { useCallback } from 'react';
import { Box, Inscription, WarningCard, WarningIcon } from '@common-fe/common-fe';

import { useOrganizationInfoStore } from '../PersonalInformation/OrganizationInfo/stores';

import useGetBeneficiaryFormUrlQuery from './useGetBeneficiaryFormUrl.query';
import useGetBeneficiaryPaperFormLink from './useGetBeneficiaryPaperFormLink';

const SpecialStatesWarning = () => {
  const organizationId = useOrganizationInfoStore((state) => state.state.organizationId);
  const staticBeneficiaryPaperFormLink = useGetBeneficiaryPaperFormLink();
  const { beneficiaryFormUrl } = useGetBeneficiaryFormUrlQuery(organizationId);

  const handleOpenForm = useCallback(() => {
    const url = beneficiaryFormUrl ? beneficiaryFormUrl : staticBeneficiaryPaperFormLink;

    if (!url) return;

    window.open(url, '_blank');
  }, [beneficiaryFormUrl, staticBeneficiaryPaperFormLink]);

  return (
    <WarningCard
      testId="SpecialStatesWarning"
      borderColor="warningBorder"
      icon={<WarningIcon />}
      containerProps={{ pad: { vertical: 'spacing16', horizontal: 'spacing24' } }}
      title={
        <Inscription color="textBody" weight="bold" lineHeight="20px">
          Important Notice for Participants in Community Property States
        </Inscription>
      }
    >
      <Box margin={{ top: 'spacing8', left: 'spacing32' }}>
        <Inscription color="textBody" lineHeight="20px">
          You reside in a community property state. If you choose to designate a beneficiary other than your
          spouse, you must submit&nbsp;
          <Inscription as="a" weight="bold" color="textAccent" cursor="pointer" onClick={handleOpenForm}>
            a signed beneficiary form
          </Inscription>
          .
        </Inscription>
        <Inscription color="textBody" lineHeight="20px" weight="bold" margin={{ top: 'spacing4' }}>
          Beneficiary designations will not be valid without your spouse’s signature.
        </Inscription>
      </Box>
    </WarningCard>
  );
};

export default SpecialStatesWarning;
